export default "__VITE_ASSET__854b0412__"